import { useQuery as e } from "@maat/store-hooks";
import { workspacesApi as t } from "@maat/api-main";
//#region src/workspaces/useAdminWorkspaceNamesQuery.ts
var n = (n) => {
	let r = [...new Set(n)].sort();
	return e({
		queryKey: ["admin-workspace-names", r],
		queryFn: () => t.adminResolveWorkspaceNames(r),
		enabled: r.length > 0,
		select: (e) => new Map(e.workspaces.map((e) => [e.id, e.name]))
	});
};
//#endregion
export { n as useAdminWorkspaceNamesQuery };
